import { useCallback, useEffect } from 'react';
import axios from 'axios';
import { useAuthStore } from "@/stores/useAuthStore";
import { useChatStore } from "@/stores/useChatStore";
import { BACKEND_URL } from '@/constants';
import { elysiaErr } from '@/lib/elysiaErr';
import { toast } from 'sonner';
import { useUIStore } from '@/stores/useUIStore';
import confetti from 'canvas-confetti';
import { TARGET_KRITIK, TARGET_TAGS } from 'shared';

export const useWinnerCheck = () => {
    // ambil nilai tags, feedback, score 
    const user = useAuthStore((state) => state.user);
    const token = useAuthStore((state) => state.token);
    const feedbackNumber = useAuthStore((state) => state.feedbackNumber);
    const tags = useChatStore((s) => s.tags);
    const rating = useAuthStore((state) => state.rating);
    const setLoadSaveTag = useChatStore((s) => s.setLoadSaveTag);
    const canSave = useChatStore((s) => s.canSave);
    const dismissSave = useChatStore((s) => s.dismissSave);

    // Winner Condition
    const hasBeenWinner = useUIStore((s) => s.hasBeenWinner);
    const hasBeenCalonWinner = useUIStore((s) => s.hasBeenCalonWinner);
    const setHasBeenWinner = useUIStore((s) => s.setHasBeenWinner);
    const setHasBeenCalonWinner = useUIStore((s) => s.setHasBeenCalonWinner);
    const setShowWinnerModal = useUIStore((s) => s.setShowWinnerModal);
    const setShowCalonWinnerModal = useUIStore((s) => s.setShowCalonWinnerModal);

    const saveUpdateTag = useCallback(async () => {
        // console.log("test saveUpdateTag")
        setLoadSaveTag(true);
        try {
            if (user?.studentId) {
                await axios.post(
                    `${BACKEND_URL}/achievement`,
                    { studentId: user?.studentId, tags },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
                toast.success("Unlocked Tags is saved!");
            } else {
                toast.info("Akun Public, data tidak akan tersimpan ke database!");
            }
            dismissSave();
        } catch (error) {
            elysiaErr(error);
        } finally {
            setLoadSaveTag(false);
        }
    }, [user?.studentId, tags, token, setLoadSaveTag, dismissSave]); // cegah re render


    useEffect(() => {
        const isCalonEligible = tags.length >= 15 && feedbackNumber >= TARGET_KRITIK && rating !== null;
        const isEligible = tags.length >= TARGET_TAGS && feedbackNumber >= TARGET_KRITIK && rating !== null;
        // console.log("useWinner: tags.length", tags.length);
        // console.log("useWinner: feedbackNumber", feedbackNumber);
        // console.log("useWinner: rating", rating);
        // console.log("==useWinner: hasBeenCalonWinner", hasBeenCalonWinner);
        // console.log("==useWinner: isCalonEligible", isCalonEligible);
        // console.log("==useWinner: user?.isTarget", user?.isTarget);
        // if (user?.studentId === 1) { /// !!!!
        //     setHasBeenCalonWinner(true);
        // }

        if (!hasBeenCalonWinner && isCalonEligible && user?.isTarget) {
            console.log("ok masuk calon winner")

            const claimCalonWinner = async () => {
                try {
                    // Await simpan tag terlebih dahulu
                    if (canSave) {
                        await saveUpdateTag();
                    }

                    // Kirim klaim winner
                    const response = await axios.post(
                        `${BACKEND_URL}/calon-winner/${user.studentId}`,
                        {},
                        {
                            headers: {
                                Authorization: `Bearer ${token}`,
                            },
                        }
                    );
                    console.log('response calonWinner', response.data);
                    if (response.data.isEligible) {
                        console.log('Berhasil klaim status calon pemenang:', response.data);
                        confetti({
                            particleCount: 100,
                            spread: 70,
                            origin: { y: 0.6 }
                        });
                        setHasBeenCalonWinner(true);
                        setShowCalonWinnerModal(true);
                    }
                } catch (error) {
                    elysiaErr(error);
                }
            };

            claimCalonWinner();
        }
        // 2nd Turn
        if (!hasBeenWinner && isEligible && user?.studentId && user.studentId !== 682) { // 682 = 1st winner
            confetti({
                particleCount: 100,
                spread: 70,
                origin: { y: 0.6 }
            });
            setHasBeenWinner(true);
            setShowWinnerModal(true);
        }

    }, [
        // 1. Data Pemicu Eligibility
        tags,
        feedbackNumber,
        rating,
        // 2. Auth & Flags
        user?.studentId,
        token,
        hasBeenWinner,
        hasBeenCalonWinner,
        canSave,
        // 3. Callback (memastikan versi paling segar)
        saveUpdateTag]);
};